module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAOElEQVRIx2O8pKzDMBCAcdTiUYtpZvGj/NKBsfj///+jFo9aPMwsDt/SOjAWM/S6jVo8avHwshgAT5ohESWuYagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/hu.png
// module id = 298
// module chunks = 0